import Box from '@mui/material/Box';
import { ReactChild, ReactChildren } from 'react';
import { MAX_WIDTH } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';

interface Props {
  children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[];
  noPadding?: boolean;
}

export const FormFieldsWrapper = ({ children, noPadding = false }: Props) => {
  return (
    <Box
      flexDirection="column"
      display="flex"
      gap={2.5}
      pt={noPadding ? 0 : 3}
      maxWidth={MAX_WIDTH}
    >
      {children}
    </Box>
  );
};
